import qs from "qs"
import axios from "axios"

// 首页-banner
export async function HomeBanner(platform) {
    const res = await axios.get("js/a/api/banner?platform=" + platform);
    return res.data;
}

// 首页-所有项目
export async function HomeAllProject() {
    const res = await axios.get("js/a/api/allProject");
    return res.data;
}

// 项目--分页查询
export async function ProjectTabsOrCustomer(data) {
    const res = await axios.post("js/a/api/project", data, { headers: { 'Content-Type': 'application/json' } });
    return res.data;
}

// 所有客户项目图片
export async function AllClients() {
    const res = await axios.get("js/a/api/cooperationImg");
    return res.data;
}


// 具体项目
export async function ProjectOne(id) {
    const res = await axios.get("js/a/api/allProject?id=" + id);
    return res.data;
}

// 首页-案例中心
export async function HomeCaseCenter(platform) {
    const res = await axios.get("js/a/api/caseCenter?platform=" + platform);
    return res.data;
}

// 首页-合作伙伴
export async function HomeCooperation() {
    const res = await axios.get("js/a/api/cooperation");
    return res.data;
}

// 联络我们
export async function ContactUs() {
    const res = await axios.get("js/a/api/contactWay");
    return res.data;
}

// 最新消息--所有
export async function AllNewsFeed() {
    const res = await axios.get("js/a/api/allNewsFeed");
    return res.data;
}

// 最新消息--分页
export async function NewsFeed(data) {
    const res = await axios.post("js/a/api/newsFeed", data, { headers: { 'Content-Type': 'application/json' } });
    return res.data;
}

// 最新消息--详情
export async function NewsFeedDetail(id) {
    const res = await axios.get("js/a/api/allNewsFeed?id=" + id);
    return res.data;
}

// 关于--团队
export async function AboutTeam() {
    const res = await axios.get("js/a/api/team");
    return res.data;
}

// 资质--所有
export async function AllQualification() {
    const res = await axios.get("js/a/api/allQualification");
    return res.data;
}

// 资质--分页
export async function Qualification(data) {
    const res = await axios.post("js/a/api/qualification", data, { headers: { 'Content-Type': 'application/json' } });
    return res.data;
}

// 资质详情
export async function QualificationDetail(id) {
    const res = await axios.get("js/a/api/allQualification?id=" + id);
    return res.data;
}

// 发展历程
export async function Development() {
    const res = await axios.get("js/a/api/development");
    return res.data;
}